import moment from 'moment'
import 'moment/locale/th'

export class DateUtils {
  static beYearFormat = (date: string, inputFormat?: string, format = 'DD MMMM YYYY') =>
    moment(date, inputFormat).locale('th').add(543, 'year').format(format)
}
